import React, { PureComponent } from 'react';
import { themr } from 'react-css-themr';
import { EnhancedField } from 'common/components/core/form/Field';
import Switch from 'common/components/core/switch';
import { HelpTooltip } from 'common/components/core/help';
import defaultTheme from './FieldWithSwitch.scss';

export const fieldWithSwitchFactory = ({ DependentField = EnhancedField }) => {
    class FieldWithSwitchComponent extends PureComponent {
        onCheck = checked => {
            const { onChange, value, getValueFromProps } = this.props;

            onChange &&
                onChange({
                    checked,
                    value: getValueFromProps
                        ? getValueFromProps(this.props)
                        : value
                });
        };
        handleDependentFieldChange = value => {
            const { onChange, checked } = this.props;

            onChange &&
                onChange({
                    checked,
                    value
                });
        };

        renderDependentField() {
            const {
                theme,
                fieldTitle,
                helpText,
                checked,
                ...others
            } = this.props;
            return (
                <div className={theme.fieldComponent}>
                    <div className={theme.fieldTitle}>
                        <div>{fieldTitle}</div>
                        {helpText ? (
                            <HelpTooltip tooltipText={helpText} />
                        ) : null}
                    </div>
                    <DependentField
                        {...others}
                        onChange={this.handleDependentFieldChange}
                        theme={theme}
                        className={theme.input}
                        disabled={!checked}
                    />
                </div>
            );
        }

        render() {
            const { theme, checked, switchLabel, ...others } = this.props;
            return (
                <div className={theme.FieldWithSwitchWrap}>
                    <div className={theme.controlComponent}>
                        <Switch
                            {...others}
                            label={switchLabel}
                            onChange={this.onCheck}
                            checked={checked}
                        />
                    </div>
                    {checked ? this.renderDependentField() : null}
                </div>
            );
        }
    }
    return themr('FieldWithSwitch', defaultTheme)(FieldWithSwitchComponent);
};

export default fieldWithSwitchFactory({});
